import React from 'react'
import { edit_recipe_path } from '../../../routes'
import { t } from '../../i18n'
import StatusBadge from '../shared/StatusBadge'
import { MoveModeUsageDetail } from './models'

interface MoveModeUsageProps {
  usage: MoveModeUsageDetail
  currentOrganizationId: number | null
}

const MoveModeUsage: React.FC<MoveModeUsageProps> = ({ usage, currentOrganizationId }) => (
  <div className="card card-robis usage-panel">
    <div className="usage-panel__label">{t('move_modes.usage.title')}</div>
    <div className="usage-panel__summary">
      {t('move_modes.usage.summary', {
        recipes: t('move_modes.usage.recipe_count', { count: usage.recipe_count }),
        meals: t('move_modes.usage.prepared_count', { count: usage.prepared_count }),
      })}
    </div>
    {usage.recipes.length > 0 && usage.live_recipe_count === 0 && (
      <div className="usage-panel__notice">{t('move_modes.usage.archived_only_notice')}</div>
    )}
    {usage.recipes.length === 0 ? (
      <p className="usage-panel__empty">{t('move_modes.usage.empty')}</p>
    ) : (
      <ul className="usage-panel__list">
        {usage.recipes.map((row) => (
          <li key={row.recipe_id} className="usage-panel__row">
            <span className="usage-panel__recipe">
              {row.organization_id === currentOrganizationId ? (
                <a href={edit_recipe_path(row.recipe_id)}>{row.recipe_name}</a>
              ) : (
                <span>{row.recipe_name}</span>
              )}
              <span className="usage-panel__organization">({row.organization_name})</span>
            </span>
            <span className="usage-panel__badges">
              {!row.live && (
                <StatusBadge label={t('move_modes.usage.archived_badge')} variant="neutral-outline" />
              )}
              {row.prepared_count > 0 && (
                <StatusBadge
                  label={t('move_modes.usage.prepared_badge', { times: row.prepared_count })}
                  variant="success-outline"
                />
              )}
            </span>
          </li>
        ))}
      </ul>
    )}
  </div>
)

export default MoveModeUsage
